import Paragraph from "immigram-ui-cmon/src/components/Paragraph/Paragraph";
import clsxm from "immigram-ui-cmon/src/lib/clsxm";
import { useTranslation } from "next-i18next";
import { ReactNode, useState } from "react";

interface CompactParagraphProps {
  description: ReactNode;
  descriptionNodeClassName?: string;
}

const CompactParagraph = (props: CompactParagraphProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Paragraph
      className={clsxm(
        "mb-3 transition-all delay-150 ease-in-out",
        !isOpen && "flex max-h-5 flex-row-reverse justify-end"
      )}
    >
      <span className={clsxm("hidden", !isOpen && "inline-block w-20")}>
        &nbsp;
        <span
          className="cursor-pointer whitespace-nowrap text-blue-600"
          onClick={() => setIsOpen(true)}
        >
          {t("application:textCut.CompactParagraph.span.seeMore")}
        </span>
      </span>
      <div
        className={clsxm(
          "[&>*]:mb-3 [&>*]:text-black-600",
          !isOpen &&
            "max-w-[380px] overflow-hidden text-ellipsis whitespace-nowrap",
          props.descriptionNodeClassName
        )}
      >
        {props.description}
      </div>
      <span
        onClick={() => setIsOpen(false)}
        className={clsxm(
          "hidden cursor-pointer whitespace-nowrap text-blue-600",
          isOpen && "inline-block"
        )}
      >
        {t("application:textCut.CompactParagraph.span.seeLess")}
      </span>
    </Paragraph>
  );
};

export default CompactParagraph;
